/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import BrokingFaqs from "./BrokingFaqs.container";

export default BrokingFaqs;
